import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";


import { useDispatch, useSelector } from "react-redux";
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
import FarmerMap from "../components/FarmerMap/FarmerMap";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import { ICONS } from "../constants/constants";
import SuperAdminDashboardCards from "../components/DashboardCards/SuperAdminDashboardCards";
import { Link } from "react-router-dom";

import { handleGetTenantData, handleGetTenantAdminsData, handleGetTenantFarmersData, handleGetTenantSuppliersData, handleGetTenantConsultantsData } from "../store/actions/tenantsActions";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import EditFarmerModal from "../components/Modals/EditFarmerModal";
import Loader from "../assets/images/loader.gif";

const SuperAdminDashboard = () => {
  const dispatch = useDispatch();
  // const { adminList } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.user);
  // const farmersListFromStore = useSelector((state) => state.farmer);
  // const suppliersListFromStore = useSelector((state) => state.supplier);
  // const consultantsListFromStore = useSelector((state) => state.consultant);
  const role = user?.role;

  // Fetch data based on user role (superadmin or admin)
  useEffect(() => {
    // dispatch(handleGetFarmersList()); // Fetch farmers list
    // dispatch(handleGetSuppliersList()); // Fetch suppliers list
    // dispatch(handleGetConsultantList()); // Fetch consultants list
  }, [dispatch, role]);

  const { tenantData, tenantAdminsData, tenantFarmersData, tenantSuppliersData, tenantConsultantsData, isLoading } = useSelector((state) => state.tenants);
  const tenantName = tenantData?.data?.tenant?.name;

  // const usersList = tenantData?.data?.tenant?.users;

  const adminList = tenantAdminsData?.data?.admins;
  const farmersListFromStore = tenantFarmersData?.data?.farmers;
  const suppliersListFromStore = tenantSuppliersData?.data?.suppliers;
  const consultantsListFromStore = tenantConsultantsData?.data?.consultants;
  // const farmersListFromStore = usersList?.filter(
  //   (user) => user.role === "farmer"
  // );
  // const suppliersListFromStore = usersList?.filter(
  //   (user) => user.role === "supplier"
  // );
  // const consultantsListFromStore = usersList?.filter(
  //   (user) => user.role === "consultant"
  // );


  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin
  useEffect(() => {
    // Fetch tenant data if the user is a superadmin and their ID is available
    if (tenantId) {
      dispatch(handleGetTenantData(tenantId));
       dispatch(handleGetTenantFarmersData(tenantId));
      dispatch(handleGetTenantAdminsData(tenantId));
            dispatch(handleGetTenantSuppliersData(tenantId));
            dispatch(handleGetTenantConsultantsData(tenantId));
    }
  }, [dispatch, tenantId]);

  // Define data for BarChartComponent
  const barChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "2024",
        data: [12, 19, 3, 5, 2, 3, 7],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "2023",
        data: [10, 14, 5, 2, 20, 30, 45],
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  // Define data for LineChartComponent
  const lineChartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Budget",
        data: [30, 45, 28, 50, 42, 56, 40, 55, 30],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
      },
      {
        label: "Return",
        data: [20, 35, 25, 45, 35, 50, 38, 48, 25],
        borderColor: "rgba(255, 159, 64, 1)",
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        tension: 0.4,
      },
      {
        label: "Earn",
        data: [25, 40, 22, 48, 38, 52, 33, 50, 28],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        tension: 0.4,
      },
    ],
  };

  // const [showEditModal, setShowEditModal] = useState(false); // State to control edit modal visibility
  // // Handle edit icon click to show edit modal
  // const handleEditClick = () => {
  //   setShowEditModal(true); // Show the edit modal
  // };
  // PDF Downloader
  const handleDownloadPDF = (admin) => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Admin Details", 14, 20);

    // Farmer Data
    // const farmArea = supplier.farmDetails?.reduce(
    //   (sum, farm) => sum + (parseFloat(farm.farm_area) || 0),
    //   0
    // );

    const tableColumn = ["Field", "Details"];
    const tableRows = [
      ["ID", admin?.id],
      ["Tenant", tenantName],
      ["Name", admin?.name],
      ["Email", admin?.email],
      ["Company", admin?.company?.name || "N/A"],
      ["CNIC", admin?.cnic || "N/A"],
      ["Address", admin?.address || "N/A"],
      // ["Farm Area", farmArea ? `${farmArea} acres` : "N/A"],
      ["Status", admin?.account_status || "Pending"],
    ];

    // AutoTable for formatting
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [0, 128, 0], // Green header background
        textColor: [255, 255, 255], // White text color
        fontStyle: "bold",
      },
    });

    // Save PDF
    doc.save(`Admin_${admin?.id}.pdf`);
  };

  const tableTitle = "Admins";

  const columns = [
    "Tenant",
    "Name",
    "Email",
    "Company",
    "Address",
    "CNIC",
    "Status",
    "Actions",
  ];
  const data = adminList?.map((admin) => ({
    Tenant: tenantName || "N/A",
    Name: admin?.name,
    Email: admin?.email,
    Company: admin?.companies[0]?.name ? admin?.companies[0]?.name : "N/A",
    Address: admin?.address || "N/A",
    CNIC: admin?.cnic || "N/A",
    Status: admin?.account_status || "N/A",
    Actions:
      admin?.account_status === "Approved" ? (
        <>
          <Link
            to={`/adminuser/${admin.id}`}
            state={{ admin }}
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img
            src={ICONS.editIcon}
            alt="Edit"
            className="cross-icon"
            onClick={handleEditClick}
          /> */}
          <img
            src={ICONS.downloadIcon}
            alt="Download"
            className="cross-icon"
            onClick={() => handleDownloadPDF(admin)} // Pass specific farmer
          />
        </>
      ) : (
        <>
          <img src={ICONS.tickIcon} alt="Alert" className="alert-icon" />
          <img
            src={ICONS.crossIcon}
            alt="Pending"
            className="pending-icon ms-2"
          />
        </>
      ),
  }));

  const cardData = [
    {
      title: "Shariah Budget",
      value: "$5000",
      colorKey: "budget",
      imageKey: "budgetIcon",
    },
    {
      title: "No of Admins",
      value: adminList?.length || 0,
      colorKey: "dues",
      imageKey: "activeAdminsImage",
    },
    {
      title: "No of Farmers",
      value: farmersListFromStore?.length || 0,
      colorKey: "farmer",
      imageKey: "farmerIcon",
    },
    {
      title: "No of Suppliers",
      value: suppliersListFromStore?.length || 0,
      colorKey: "supplier",
      imageKey: "supplierIcon",
    },
    {
      title: "No of Consultants",
      value: consultantsListFromStore?.length || 0,
      colorKey: "consultant",
      imageKey: "consultantIcon",
    },
  ];
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container">
          <TitleComponent title="Dashboard" />
        
          <SuperAdminDashboardCards cardData={cardData} />
        </Col>
      </Row>

      <Row className="two-columns">
        <Col className="component-container">
          <TitleComponent title="Productions Details" />
          <BarChartComponent data={barChartData} />
        </Col>
        <Col className="component-container right">
          <TitleComponent title="Finance" />
          <LineChartComponent data={lineChartData} />
        </Col>
      </Row>

      <Row className="two-columns-map">
        <Col className="component-container ">
          <TableComponent
            columns={columns}
            data={data}
            title={tableTitle}
            showSearchBar={false}
            showFilter={false}
            showTabs={false}
            showColors={false}
            showCount={false}
            onEdit={false}
            onDelete={false}
            onDownload={false}
            showAddNewAdmin={false}
            searchplaceholder="Search by Farmer’s Name, CNIC, Crop"
            customClass="ms-3"
            showRating={false}
          />
        </Col>
        <Col className="component-container-map right">
          <FarmerMap />
        </Col>
      </Row>
      {/* <EditFarmerModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        user={user}
        userType={user?.userdatarole}
      /> */}
    </Container>
  );
};

export default SuperAdminDashboard;
